import { render } from "./ListIps.vue?vue&type=template&id=729b1b5e"
import script from "./ListIps.vue?vue&type=script&lang=js"
export * from "./ListIps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__